
import { registerMicroApps, start, initGlobalState } from "qiankun";
import appsCommunicator from "./appsComunicator";
import { getApps } from "./apps";

export default async ({ context, options }) => {  

  const agnosticStoreSync = initGlobalState(options.globalState)

  context.config.globalProperties.$onGlobalStateChange = agnosticStoreSync.onGlobalStateChange;
  context.config.globalProperties.$setGlobalState = agnosticStoreSync.setGlobalState;
  context.config.globalProperties.$keycloak = options.keycloak;

  agnosticStoreSync.setGlobalState && agnosticStoreSync.setGlobalState({
    keycloak: options.keycloak
  })

  const apps = await getApps()
  const mainAppProps = await appsCommunicator(context)

  registerMicroApps(
    apps.map(item => ({
      ...item,
      props: {
        mainAppProps        
      },
    }))
  );

  start({prefetch: false, singular: false});  
}
